import { terminationEvents } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

const stageStyle: Record<string, string> = {
  已解约: "border-primary-300 bg-primary-50 text-primary-700",
  暂停合作: "border-accent-300 bg-accent-50 text-accent-800",
  观察中: "border-secondary-300 bg-secondary-50 text-secondary-800",
};

const stageDot: Record<string, string> = {
  已解约: "bg-primary-500",
  暂停合作: "bg-accent-500",
  观察中: "bg-secondary-500",
};

export default function TerminationTimeline() {
  return (
    <section id="termination" className="w-full border-b border-background-200 bg-background-100 py-10 md:py-14">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <SectionHeading
          no="04"
          title="品牌解约动态"
          desc="品牌的态度往往写在动作里：先下架哪块物料、保留哪条产品线、用哪种口径回应。按时间顺序看，切割的节奏比声明更清楚。"
          actionLabel="完整时间线"
          actionHref="#termination"
        />

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
          <div className="lg:col-span-8">
            <ol className="relative ml-2 border-l border-background-300 pl-6">
              {terminationEvents.map((ev) => (
                <li key={`${ev.date}-${ev.brand}`} className="relative pb-7 last:pb-0">
                  <span
                    className={`absolute -left-[31px] top-1.5 h-3 w-3 rounded-full ring-4 ring-background-100 ${stageDot[ev.stage]}`}
                  ></span>
                  <div className="flex flex-col gap-2 rounded-lg border border-background-200 bg-background-50 p-4 md:flex-row md:items-center md:justify-between md:gap-4 md:p-5">
                    <div className="min-w-0">
                      <div className="flex flex-wrap items-center gap-2">
                        <span className="font-heading text-sm font-bold text-foreground-950">{ev.date}</span>
                        <span className="text-sm font-semibold text-foreground-800">{ev.brand}</span>
                        <span
                          className={`rounded-full border px-2 py-0.5 text-[10px] font-semibold ${stageStyle[ev.stage]}`}
                        >
                          {ev.stage}
                        </span>
                      </div>
                      <p className="mt-1.5 text-sm font-medium text-foreground-900">{ev.action}</p>
                      <p className="mt-1 text-xs leading-relaxed text-foreground-500">{ev.detail}</p>
                    </div>
                    <a
                      href="#subscribe"
                      className="flex shrink-0 items-center gap-1 whitespace-nowrap text-xs font-semibold text-primary-600 hover:text-primary-700"
                    >
                      关注同类
                      <i className="ri-add-line w-3.5 h-3.5 flex items-center justify-center"></i>
                    </a>
                  </div>
                </li>
              ))}
            </ol>
          </div>

          <aside className="lg:col-span-4">
            <div className="sticky top-40 space-y-4">
              <div className="rounded-lg border border-background-200 bg-background-50 p-5">
                <h4 className="font-heading text-base font-bold text-foreground-950">近 30 天切割动作</h4>
                <div className="mt-4 space-y-3">
                  {[
                    { k: "物料下架", v: 34, c: "bg-primary-500" },
                    { k: "官宣延后", v: 21, c: "bg-accent-500" },
                    { k: "合约不续", v: 15, c: "bg-foreground-700" },
                    { k: "保留单线", v: 9, c: "bg-secondary-500" },
                  ].map((row) => (
                    <div key={row.k}>
                      <div className="mb-1 flex items-center justify-between text-xs text-foreground-600">
                        <span>{row.k}</span>
                        <span className="font-semibold text-foreground-900">{row.v}</span>
                      </div>
                      <div className="h-2 w-full overflow-hidden rounded-full bg-background-200">
                        <div className={`h-full rounded-full ${row.c}`} style={{ width: `${(row.v / 34) * 100}%` }}></div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="rounded-lg border border-background-200 bg-background-50 p-5">
                <h4 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                  <i className="ri-lightbulb-line w-5 h-5 flex items-center justify-center text-accent-600"></i>
                  避雷提示
                </h4>
                <p className="mt-3 text-xs leading-relaxed text-foreground-600">
                  合约中提前约定「舆情条款」与物料撤回窗口，能在争议出现时把损失控制在一个可预期的范围内。
                </p>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}